import { Signal } from '../core/Signal';

export interface AssetsLoadedPayload {
  totalAssets: number;
  timestamp: number;
}

export interface AssetLoadErrorPayload {
  assetKey: string;
  assetType: string;
  error: Error;
  timestamp: number;
}

export const createAssetSignals = (debugMode: boolean = false) => ({
  assetsLoaded: new Signal<AssetsLoadedPayload>(
    'assets.assetsLoaded',
    debugMode
  ),
  assetLoadError: new Signal<AssetLoadErrorPayload>(
    'assets.assetLoadError',
    debugMode
  ),
});

export type AssetSignals = ReturnType<typeof createAssetSignals>;
